import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import { Home, ArrowBack } from "@mui/icons-material";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <Box
      sx={{
        minHeight: "60vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"}}
    >
      <Container maxWidth="md" sx={{ textAlign: "center", py: 8 }}>
        <Typography
          variant="h1"
          fontWeight={800}
          sx={{
            fontSize: { xs: "6rem", md: "8rem" },
            background: "linear-gradient(45deg, #1565c0, #2196f3)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            mb: 2,
          }}
        >
          404
        </Typography>
        
        <Typography
          variant="h4"
          fontWeight={700}
          color="text.primary"
          mb={2}
        >
          Page Not Found
        </Typography>
        
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ mb: 4, maxWidth: "500px", mx: "auto" }}
        >
          The page you're looking for doesn't exist or has been moved. 
          Let's get you back to familiar territory.
        </Typography>

        <Box sx={{ display: "flex", gap: 2, justifyContent: "center", flexWrap: "wrap" }}>
          <Button
            component={Link}
            to="/"
            variant="contained"
            size="large"
            startIcon={<Home />}
            sx={{
              px: 4,
              py: 1.5,
              background: "linear-gradient(45deg, #1565c0, #2196f3)",
            }}
          >
            Go Home
          </Button>
          
          <Button
            variant="outlined"
            size="large"
            startIcon={<ArrowBack />}
            onClick={() => window.history.back()}
            sx={{ px: 4, py: 1.5 }}
          >
            Go Back
          </Button>
        </Box>
      </Container>
    </Box>
  );
}